import React, { useEffect } from "react";
import { Table } from "antd";
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { useDispatch, useSelector } from "react-redux";
import AwardForm from "./AwardForm"; 
import PopupButton from "components/button/PopupButton";
import { handleTableChange } from "../../../../utils/index";
import {
  getAwardList,
  doAwardDelete,
  doAwardReset,
} from "../../../../redux/award/awardState";
import { displayIcon } from "variables/icons";
import { MODULE_AWARDS } from "variables/modules";

const AwardTable = ({ }) => {
    const dispatch = useDispatch();
    const recordList = useSelector((state) => state.award.awardList?.items);
    const pagination = useSelector((state) => state.award.awardList?.pagination);
    const filters = useSelector((state) => state.award.arwardList?.filters);

    const doSearch = (filters) => dispatch(getAwardList(filters));
    const doDelete = (id) => dispatch(doAwardDelete(id));
    const doRecordReset = () => dispatch(doAwardReset());

  const columns = [
    {
      title: "Award Title",
      dataIndex: "awd_title",
      key: "awd_title",
      width: "25%",
      render: (awd_title) => <span>{awd_title}</span>,
    },
    {
      title: "Icon",
      dataIndex: "awd_icon",
      key: "awd_icon",
      width: "6%",
      render: (awd_icon) => <span>{displayIcon(awd_icon, "w-5 h-5 title-text")}</span>,
    },
    {
      title: "Description",
      dataIndex: "awd_description",
      key: "awd_description",
      width: "50%",
      render: (awd_description) => <span>{awd_description}</span>,
    },
    {
      title: (
        <PopupButton id="add_award" title="Add Award" label="Add" btnClass="btn-small" action="add" moduleId={MODULE_AWARDS}>
          <AwardForm recordId="0" mode="edit" />
        </PopupButton>
      ),
      dataIndex: "awd_id",
      key: "awd_id",
      width: "15%",
      render: (_, record) => (
        <CrudOption
          baseRoute="/console/awards"
          recordId={record?.awd_id}
          deleteHandler={doDelete}
          allowEdit={true}
          allowView={false}
          editMode="modal"
          modalWidth={900}
          title="Edit Award"
          closeHandler={doRecordReset}
          editHandler={(recordId, doRecordReset ) => (
            <AwardForm recordId={recordId} mode="edit" onCancel={doRecordReset} />
          )}
        />
      ),
    },
  ];

	useEffect(() => {
		dispatch(getAwardList({paginate: pagination.per_page}));
	}, [dispatch, pagination.per_page]);
	
  return (
    <Card extra={"w-full h-full p-4"}>
      <div className="h-full overflow-x-scroll xl:overflow-x-hidden">
        <Table
          dataSource={recordList}
          columns={columns}
          rowKey={(record) => record.awd_id}
          scroll={{ x: "max-content" }}
		      pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}   
          onChange={handleTableChange(doSearch, filters)}
        />
      </div>
    </Card>
  );
};

export default AwardTable;
